/* Homepage work starts near the viewport, with an immediate interaction fallback. */
(function () {
  'use strict';
  var homepage = document.body.classList.contains('template-index');
  var editor = window.Shopify && window.Shopify.designMode;
  window.novWhenNear = function (element, callback) {
    var done = false;
    var observer;
    var pending = [];
    function prepare() {
      pending = Array.from(element.querySelectorAll('.nov-slick-carousel:not(.slick-initialized)'));
      pending.forEach(function (slider) {
        ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
          var attr = size === 'xl' ? 'data-items' : 'data-items_' + size;
          var count = Number(slider.getAttribute(attr)) || Number(slider.getAttribute('data-items')) || 1;
          slider.style.setProperty('--nov-cols-' + size, Math.max(1, count));
        });
        var rows = Number(slider.getAttribute('data-row')) || 1;
        slider.style.setProperty('--nov-rows', rows);
        slider.style.setProperty('--nov-rows-mobile', Number(slider.getAttribute('data-row_mobile')) || rows);
        slider.classList.add('nov-deferred-carousel');
      });
    }
    function cleanup() {
      if (observer) observer.disconnect();
      pending.forEach(function (slider) { slider.classList.remove('nov-deferred-carousel'); });
      element.removeEventListener('pointerdown', run, true);
      element.removeEventListener('focusin', run, true);
      element.removeEventListener('click', run, true);
    }
    function run() {
      if (done) return;
      done = true;
      cleanup();
      if (element.isConnected) callback();
    }
    if (!homepage || editor || !('IntersectionObserver' in window) ||
        element.getBoundingClientRect().top < window.innerHeight + 200) {
      run();
    } else {
      prepare();
      observer = new IntersectionObserver(function (entries) {
        if (entries.some(function (entry) { return entry.isIntersecting; })) run();
      }, { rootMargin: '200px 0px' });
      observer.observe(element);
      element.addEventListener('pointerdown', run, true);
      element.addEventListener('focusin', run, true);
      element.addEventListener('click', run, true);
    }
    return function () { done = true; cleanup(); };
  };

  // Templates keep hidden option lists out of layout and slider cloning work.
  // Hydrate before the theme's delegated swatch/quick-add handlers see the click.
  if (homepage && !editor) {
    function hydrate(event) {
      var card = event.target.closest && event.target.closest('.item-product');
      if (!card) return;
      var template = card.querySelector('template[data-nov-quick-add]');
      if (!template) return;
      template.replaceWith(template.content.cloneNode(true));
    }
    document.addEventListener('click', hydrate, true);
    document.addEventListener('focusin', hydrate, true);
  }

  // Optional popup runtimes are fetched only for their own interactions.
  var pluginPromises = {};
  var waitingTriggers = new WeakSet();
  function pluginReady(name) {
    return !!(window.jQuery && (name === 'fancybox' ? jQuery.fn.fancybox : jQuery.magnificPopup));
  }
  window.novLoadPlugin = function (name) {
    if (pluginReady(name)) return Promise.resolve();
    if (pluginPromises[name]) return pluginPromises[name];
    var assets = window.novPluginAssets || {};
    if (!assets[name]) return Promise.reject(new Error('Unknown optional plugin: ' + name));
    pluginPromises[name] = new Promise(function (resolve, reject) {
      var script = document.createElement('script');
      script.src = assets[name];
      script.async = true;
      function fail() {
        script.remove();
        delete pluginPromises[name];
        reject(new Error('Could not load optional plugin: ' + name));
      }
      script.onload = function () {
        if (pluginReady(name)) resolve();
        else fail();
      };
      script.onerror = fail;
      document.head.appendChild(script);
    });
    return pluginPromises[name];
  };
  function popupTrigger(event) {
    return event.target.closest && event.target.closest('[data-fancybox], .btnProductQuickview');
  }
  function popupName(trigger) {
    return trigger.hasAttribute('data-fancybox') ? 'fancybox' : 'quickview';
  }
  function warmPopup(event) {
    var trigger = popupTrigger(event);
    if (trigger) window.novLoadPlugin(popupName(trigger)).catch(function () {});
  }
  document.addEventListener('pointerdown', warmPopup, true);
  document.addEventListener('focusin', warmPopup, true);
  document.addEventListener('click', function (event) {
    var trigger = popupTrigger(event);
    if (!trigger || pluginReady(popupName(trigger))) return;
    // Preserve modified link clicks and the browser's open-in-new-tab behavior.
    if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button > 0) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (waitingTriggers.has(trigger)) return;
    waitingTriggers.add(trigger);
    var previousBusy = trigger.getAttribute('aria-busy');
    trigger.setAttribute('aria-busy', 'true');
    function finish() {
      waitingTriggers.delete(trigger);
      if (previousBusy === null) trigger.removeAttribute('aria-busy');
      else trigger.setAttribute('aria-busy', previousBusy);
    }
    window.novLoadPlugin(popupName(trigger)).then(function () {
      // Allow the library's jQuery-ready handlers to register before replaying.
      setTimeout(function () {
        finish();
        if (trigger.isConnected) trigger.click();
      }, 0);
    }).catch(function () {
      finish();
      var href = trigger.getAttribute('data-product-url') || trigger.getAttribute('href');
      if (href && href !== '#') window.location.assign(href);
    });
  }, true);

  function loadHashGallery() {
    var hash;
    try { hash = decodeURIComponent(window.location.hash.slice(1)); } catch (error) { return; }
    if (!hash) return;
    var galleries = document.querySelectorAll('[data-fancybox]');
    for (var i = 0; i < galleries.length; i++) {
      var group = galleries[i].getAttribute('data-fancybox');
      if (group && (hash === group || hash.indexOf(group + '-') === 0)) {
        window.novLoadPlugin('fancybox').catch(function () {});
        break;
      }
    }
  }
  loadHashGallery();
  window.addEventListener('hashchange', loadHashGallery);
})();
